import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { FunctionComponent, ReactNode } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { spacings } from '../spacings';
import {
  PageHeaderText,
  PageHeaderTextProps,
} from '../TextStyles/PageHeaderText';
import {
  SubheadingText,
  SubheadingTextProps,
} from '../TextStyles/SubheadingText';

interface OwnProps {
  pageHeader: ReactNode;
  subheading: ReactNode;
  SubheadingProps?: SubheadingTextProps;
  PageHeaderProps?: PageHeaderTextProps;
}

interface PageHeaderWithSubheadingProps
  extends OwnProps,
    WithStyles<typeof styles> {}

const PageHeaderWithSubheadingBase: FunctionComponent<
  PageHeaderWithSubheadingProps
> = ({ PageHeaderProps, SubheadingProps, pageHeader, subheading, classes }) => (
  <div className={classes.root}>
    <PageHeaderText {...PageHeaderProps}>{pageHeader}</PageHeaderText>
    <SubheadingText {...SubheadingProps} className={classes.subheading}>
      {subheading}
    </SubheadingText>
  </div>
);

// styled
const styles = (theme: Theme) => {
  const {
    page: { top: pageTopSpacing },
    textGroup,
  } = spacings(theme);

  return createStyles({
    root: {
      ...pageTopSpacing,
    },
    subheading: {
      ...textGroup,
    },
  });
};

const enhance = compose<PageHeaderWithSubheadingProps, OwnProps>(
  pure,
  withStyles(styles),
);

/**
 * Page header with subheading
 *
 * @zeplin {@link https://zpl.io/25OLypJ }
 */
export const PageHeaderWithSubheading = enhance(PageHeaderWithSubheadingBase);

PageHeaderWithSubheading.displayName = 'PageHeaderWithSubheading';
